/* @flow */

import { createReducer } from 'src/shared/core/util/reducerUtils';
import * as types from '../action/inspirationActionTypes';

import type { State } from 'src/shared/core/type/reduxTypes';

/*
 |------------------------------------------------------------------------------
 | Initial state
 |------------------------------------------------------------------------------
 */

const initialState = {
  isFetching: false,
  result: [],
};

/*
 |------------------------------------------------------------------------------
 | Reducers
 |------------------------------------------------------------------------------
 */

const handleRequest = (state: State) => ({
  ...state,
  isFetching: true,
  result: [],
});

const handleSuccess = (state: State, { result }: Object) => ({
  ...state,
  isFetching: false,
  result,
});

const reset = (state: State) => ({
  ...state,
  isFetching: false,
  result: [],
});

export default createReducer(initialState, {
  [types.FETCH_EVENT_TOPIC_INSPIRATIONS]: handleRequest,
  [types.FETCH_EVENT_TOPIC_INSPIRATIONS_SUCCESS]: handleSuccess,
  [types.FETCH_EVENT_TOPIC_INSPIRATIONS_FAILURE]: reset,
});
